import React, { useState, useEffect,useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes, Route, Navigate } from 'react-router-dom'; // Import Navigate here
import './App.css';
import SignInSide from './components/signin';
import Dashboard from './components/dashboard';
import StudentManagement from './components/studentManagement';
import UserManagement from './components/userManagement';
// import FeesManagement from './components/FeesManagement';
import FeePayment from './components/FeePayment';
// import StudentManagement from './components/studentManagement';
import StorePurchase from './components/StorePurchase';
import StorePayment from './components/StorePayment';
import TransportPayment from './components/TransportPayment';
import AnnualSubscription from './components/AnnualSubscription';
import Refund from './components/Refund';
import InventoryRefund from './components/InventoryRefund';
import PaymentSummary from './components/PaymentSummary';
import FeesReport from './components/FeesReport';
import FeesManagementModal from './components/FeesManagementModal';
import FeeSlab from './components/FeesSlab';
import FeesManagement from './components/FeesManagement';
import InventoryDashboard from './components/InventoryDashboard';
import InventoryManagementDashboard from './components/InventoryManagementDashboard';
import CreateProducts from './components/CreateProducts';
import Category from './components/Category';
import Brand from './components/Brand';
import Attribute from './components/Attribute';
import Products from './components/Produts';
import Sale from './components/Sales'
import Profile from './components/signinform';
import SaveUser from "./components/userForm";
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedRouteSuperAdmin from './components/ProtectedRouteSuperAdmin';
import Layout from './components/layout';
import Stock from "./components/Stock";
import axios from 'axios'; // Add this import for axios
import StoreManagementDashboard from './components/StoreManagementDashboard';
import IssueProduct from './components/IssueProducts';
import RefundLogs from "./components/RefundLog";
import EventandStaff from "./components/Issue staff&Event Dash";
import EventandStaffDash from "./components/Event&staff";
import IssueEvent from "./components/Event";
// import IssueEvent from "./components/issueevent2";

import CreateEventandStaffDash from "./components/createEvent&IssueproDash";
import IssueBrand from "./components/IssueBrandEven";
import IssueCategory from "./components/IssueCategory";
// import useSessionManager from './components/useSessionManager';
import Kits from './components/Kits';
import IssueKits from './components/IssueKits';
import KitPaymentManagement from './components/KitPaymentManagement';
import kitPayment from './components/KitsPayment';
import { AcademicYearProvider } from './components/AcademicYearContext';
import { OtpProvider } from './components/OtpContext';
import ManageSettings from './components/ManageSettings';
// import jwtDecode from 'jwt-decode';
import { jwtDecode } from 'jwt-decode';
const isAuthenticated = () => {
  const roleID = localStorage.getItem('roleID');
  
  if (!roleID) {
    localStorage.clear();
    return false;      
  }

  console.log("roleID =", roleID);
   
  if(roleID !== "") {
    console.log("Printed");
    return true;
  }

};

function App() {
 
  
  return (
    <AcademicYearProvider>
      <OtpProvider>
        <div className="App">
          <Routes>
            <Route path="/signin" element={<SignInSide />} />
            <Route path="/dashboard" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Dashboard} />} />
        <Route path="/user-management" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={UserManagement} />} />
        <Route path="/student-management" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={StudentManagement} />} />
        <Route path="/fees-management-modal" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={FeesManagementModal} />} />
        <Route path="/fees-management" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={FeesReport} />} />
        <Route path="/fees-report" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={FeesReport} />} />
        <Route path="/fees-slab" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={FeeSlab} />} />
        <Route path="/fee-payment" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={FeePayment} />} />
        <Route path="/store-purchase" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={StorePurchase} />} />
        <Route path="/store-payment" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={StorePayment} />} />
        <Route path="/transport-payment" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={TransportPayment} />} />
        <Route path="/annual-subscription" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={AnnualSubscription} />} />
        <Route path="/refund" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Refund} />} />
        <Route path="/inventory-refund" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={InventoryRefund} />} /> 
        <Route path="/payment-summary" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={PaymentSummary} />} /> 
        <Route path="/erp-management" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={InventoryDashboard} />} /> 
        <Route path="/erp-store" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={StoreManagementDashboard} />} /> 
        <Route path="/erp-md" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={InventoryManagementDashboard} />} /> 
        <Route path="/erp-product" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={CreateProducts} />} /> 
        <Route path="/erp-cat" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Category} />} /> 
        <Route path="/erp-brand" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Brand} />} /> 
        <Route path="/erp-attri" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Attribute} />} /> 
        <Route path="/erp-Products" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Products} />} /> 
        <Route path="/erp-stock" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Stock} />} /> 
        <Route path="/erp-refundlog" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={RefundLogs} />} />   
        <Route path="/profile" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Profile} />} />  
        <Route path="/store-Issue" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueProduct} />} />  

        <Route path="/issue-event" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={EventandStaffDash} />} />  
        <Route path="/issue-eventsmain" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={EventandStaffDash} />} />  
        <Route path="/Issue-evntbrand" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueBrand} />} />  
        <Route path="/issue-category" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={EventandStaffDash} />} />  
        <Route path="/issue-CreateEv" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={CreateEventandStaffDash} />} />  
        <Route path="/issue-categorymain" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueCategory} />} />  
        <Route path="/issue-eventsmain2" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueEvent} />} />  
        {/* <Route path="/issue-eventsmain2" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueEvent} />} />   */}

        <Route path="/issue-event&staff" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={EventandStaff} />} />  
        <Route path="/erp-kits" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Kits} />} /> 
        <Route path="/store-sale" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={Sale} />} />  
        <Route path="/store-issue-kit" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={IssueKits} />} />  
        <Route path="/kit-payment-management" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={KitPaymentManagement} />} />  
        <Route path="/kit-payment" element={<ProtectedRoute isAuthenticated={isAuthenticated} component={kitPayment} />} />
        <Route path="/manage-settings" element={<ProtectedRouteSuperAdmin isAuthenticated={isAuthenticated} component={ManageSettings} />} />
        <Route path="*" element={<Navigate to="/signin" />} />  
      </Routes>       
        </div>
      </OtpProvider>
    </AcademicYearProvider>
  );      
}   


export default App;


































